<template>
  <v-container>
    <CarouselBar :types="types" @selectTab="selectTab" />
    <div v-if="ready">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="section-content"
        :style="{ display: item.groupType == currentTab ? 'block' : 'none' }"
      >
        <template v-if="item.orderList.length > 0">
          <OrderItem
            v-for="(unit, i) in item.orderList"
            :key="i"
            :order="unit"
            :order-type="orderType"
            :statusType="item.groupType"
            class="order-items"
          />
        </template>
        <template v-else>
          <div class="section-content no-order-section">
            <div class="logo">
              <img src="@/assets/img/noorder.svg" class="noorder" />
            </div>
            <div class="title">您沒有任何訂單喔</div>
            <div class="subtitle">快到商城來逛逛</div>
          </div>
        </template>
      </div>
    </div>
    <Spinner v-else bgc="#f6f6f6" />
  </v-container>
</template>

<script>
import CarouselBar from '@/components/order/CarouselBar.vue'
import OrderItem from '@/components/order/OrderItem.vue'
import Spinner from '@/components/shared/Spinner.vue'

export default {
  name: 'OrderList',
  components: {
    CarouselBar,
    OrderItem,
    Spinner,
  },
  props: {
    orderType: String,
  },
  data: function() {
    return {
      items: [
        { orderList: [] },
        { orderList: [] },
        { orderList: [] },
        { orderList: [] },
        { orderList: [] },
      ],
      currentTab: 0,
      isGoods: false,
      types: ['可使用', '已使用', '已過期', '退款', '客服處理中'],
      ready: false,
    }
  },
  created: function() {
    this.updatePurchaseType()
    // if (typeof window.host_renewTokenInfo != 'undefined') {
    //   window.host_renewTokenInfo()
    // }
    // const self = this
    // api.loginCheck().then(function(res) {
    //   console.log('loginCheck-' + res)
    //   if (res) {
    //     console.log('1')
    //     self.updatePurchaseType()
    //   } else {
    //     console.log('2')
    //     window.setTimeout(() => self.updatePurchaseType(), 2000)
    //   }
    // })
  },
  methods: {
    getOrderListRedemption(checkIsCoffee) {
      const self = this
      api
        .getOrderListRedemption(checkIsCoffee)
        .then(function(res) {
          if (res.data.length !== 0) {
            res.data.forEach(item => {
              self.items.push({
                groupName: item.groupName,
                groupType: item.groupType,
                orderList: item.orderList,
              })
            })
          }
        })
        .catch(function(err) {
          console.log(err)
        })
      this.ready = true
    },
    getOrderListDelivery() {
      const self = this
      api
        .getOrderListDelivery()
        .then(function(res) {
          if (res.data.length !== 0) {
            res.data.forEach(item => {
              self.items.push({
                groupName: item.groupName,
                groupType: item.groupType,
                orderList: item.orderList,
              })
            })
          }
        })
        .catch(function(err) {
          console.log(err)
        })
      this.ready = true
    },
    selectTab(index) {
      this.currentTab = index
      window.sessionStorage.setItem('lastCurrentTab', index.toString())
    },
    updatePurchaseType(type) {
      console.log('updatePurchaseType')
      if (this.orderType === 'GOODS') {
        this.isGoods = true
        this.types = ['待出貨', '待收貨', '確認收貨', '退貨', '客服處理中']
        this.getOrderListDelivery()
      } else if (this.orderType === 'COFFEE') {
        this.isGoods = true
        this.types = ['可使用', '已使用', '已過期', '退款', '客服處理中']
        this.getOrderListRedemption(true)
      } else {
        this.isGoods = false
        this.types = ['可使用', '已使用', '已過期', '退款', '客服處理中']
        this.getOrderListRedemption(false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 0px !important;
  background-color: #f3f3f3;
}

.section-content {
  min-height: calc(100vh - 48px);
}

.order-items {
  margin-top: 8px;
}

.no-order-section {
  display: flex;
  flex-flow: column;
  justify-content: center;
  height: calc(100vh - 141px);
  .logo {
    text-align: center;
    display: block;
  }
  .title {
    font-family: PingFangTC;
    font-weight: bold;
    font-size: 18px;
    color: #9b9b9b;
    display: block;
    text-align: center;
    font-size: 1.5em !important;
    line-height: 2em;
  }
  .subtitle {
    font-family: PingFangTC;
    font-weight: normal;
    font-size: 14px;
    color: #9b9b9b;
    display: block;
    text-align: center;
    font-size: 1em !important;
    line-height: 1.2em;
  }
  .noorder {
    width: 72px;
    height: 72px;
    object-fit: contain;
  }
}
</style>
